import axiosApi, { setHeader } from "api/root.api";

export const getProject = async (token, id) => {
  const urlEnd = `/editor/project/v1/${id}`;
  setHeader("Authorization", `Bearer ${token}`);
  const response = await axiosApi.get(urlEnd);
  const result = response.data;
  return result;
};
